// extracted by mini-css-extract-plugin
export default {"header":"SectionHeader_header__j+IvE","title":"SectionHeader_title__msbx5"};